<template>
  <v-container fluid full-height grid-list-md>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-layout row wrap>
          <v-flex sm3 v-if="user.role.roleName != 'SALE'">
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3 v-if="user.role.roleName != 'SALE'">
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.toDate"></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex sm3>
            <v-text-field name="wayAssignNo" label="Way Assign No" v-model="queryParams.wayAssignNo" type="text"></v-text-field>
          </v-flex>
          <v-flex sm3 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'BRANCH_ADMIN'">
            <v-select
              :items="customerShopList"
              label="Choose Customer Shop..."
              item-text="name"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.customerShopId"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="status"
              label="Status"
              item-text="label"
              item-value="value"
              v-model="queryParams.status"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="marketingList"
              label="Marketing"
              item-text="username"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.cashierId"
            ></v-select>
          </v-flex> 
          <v-flex sm3>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="checkInReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            expand
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.status }}</td>
                <td>{{ props.item.checkInBy }}</td>
                <td>{{ props.item.checkInDateInMilliSeconds | format-ms-date-time }}</td>
                <td>{{ props.item.wayAssignNo }}</td>
                <td>{{ props.item.customerShopName }}</td>
                <td>{{ props.item.remark }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
        <!-- </v-expansion-panel> -->
      </v-flex>
    </v-layout>
    <!-- reprint sale slip hidden area -->
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { checkInReportService } from "../../services/check-in-report-service";
import { customerShopService } from "../../services/customer-shop-service";
import { Sale } from "../../models/model";
import { saleService } from "../../services/sale-service";
import { userService } from "../../services/user-service";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "CheckInReportList",

  components: { Loading },
  data: () => ({
    time: false,
    showListLoading: false,
    dialog: false,
    showFilters: false,
    user: JSON.parse(localStorage.getItem("user")),
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true
      },
      {
        text: "General Reports",
        disabled: true
      },
      {
        text: "Check-in Report",
        disabled: true
      }
    ],
    headers: [
      { text: "Status", value: "status" },
      { text: "Marketing ",  value: "check_in_by" },
      { text: "Check-in Date", align: "left", value: "check_in_date" },
       { text: "Way Assign No", value: "way_assign_no" },
       { text: "Customer Shop Name", value: "csh.name" },
      { text: "Remark", value: "remark" }
    ],

    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "check_in_date",
      totalItems: 0
    },
    rowsPerPageItems2: [25, 50, 100],
    pagination2: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      totalItems: 0
    },

    customerShopList: [],
    checkInReportList: [],

    saleDetailList: [],
    marketingList: [],
    sale: new Sale(),
    totalAmount: 0,
    totalNetAmount: 0,
    totalDiscountAmount: 0,
    totalTaxAmount: 0,
    totalReturnAmount: 0,
    wayAssignNo: "",
    totalRows: 0,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      wayAssignNo: "",
      customerShopId: "",
      userName: "",
      status: "",
      cashierId: ""
    },
    buttonLoading: false,
    isLoading: false,
    status: [
      { label: "----All----", value: "" },
      { label: "CHECK-IN", value: "CHECK_IN" },
      { label: "SALE", value: "SALE" }
    ],
    fullPage: true
  }),
  watch: {
    pagination: {
      handler() {
        this.getCheckInReportList();

      },
      deep: true
    }
  },
  created() {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role.roleName == "ADMIN") {
      this.getAllCustomerShop();
    }

    if (user.role.roleName == "SALE") {
      this.queryParams.userName = user.username;
    }
    this.onSearch();
    //for deep linking
    if (this.$route.query.userName) {
      this.queryParams.userName = this.$route.query.userName;
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getAllCashier();
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "check-in-report", query: this.queryParams });
      this.getCheckInReportList();

    },
    getCheckInReportList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      checkInReportService
        .getCheckInReportList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.checkInReportList = res.data.checkInList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },





    getAllCustomerShop() {
      customerShopService
        .getAllCustomerShop()
        .then(res => {
          this.customerShopList = res.data.customerShopList;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.customerShopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },

    getAllCashier() {
      userService
        .getAllMarketing()
        .then(res => {
          this.marketingList = res.data;
          let findAll = {
            id: "",
            username: "---All---"
          };
          this.marketingList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.responseError.data.message;
          }
        });
    },

  

    reprint(sale) {
      this.isLoading = true;

        this.printDirectSaleInvoiceById(sale.id);

    },

    printDirectSaleInvoiceById(id) {
      saleService
        .printDirectSaleInvoiceById(id)
        .then(res => {
          var blob = res;
          saleService.showWindowDialog(blob, "DirectSaleInvoice-" + id);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    reprintSaleDetail(divName) {
      var printContents = document.getElementById(divName).innerHTML;
      var reprintWindow = window.open("", "MsgWindow", "width=500,height=500");
      reprintWindow.document.write(printContents);
      setTimeout(() => {
        reprintWindow.print();
        reprintWindow.close();
      }, 600);
    },

    clear() {
      this.queryParams.data = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
    }
  }
};
</script>
